export default "__VITE_ASSET__DrrOamT2__"